export default __webpack_public_path__ + "media/images/mailer-new/heading/key-disabled-b75599496c29baaea98fe53502fc4072.png";